import React from 'react';
import { Form, Container, Row, Col } from 'react-bootstrap';
import TitleBlock from '../TitleBlock';
const ContactBox = () => {
  return (
    <div style={{ background: '#F9F6EE',paddingBottom:"50px" }}>
      <TitleBlock
        number='07'
        pretitle='say hi'
        title='Get in touch'
        desc='Fill out the details below and we will get in touch with you shortly'
      />

      <Container>
        <Form>
          <Row>
            <Col md={6}>
              <Form.Group className='mb-4' controlId='formBasicEmail'>
                <Form.Control type='text' placeholder='Full Name' />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className='mb-4' controlId='formBasicEmail'>
                <Form.Control type='email' placeholder='Email Address' />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className='mb-4' controlId='formBasicEmail'>
                <Form.Control type='text' placeholder='Phone Number' />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className='mb-4' controlId='formBasicEmail'>
                <Form.Control
                  as='textarea'
                  placeholder='Leave a comment here'
                  style={{ height: '100px' }}
                />{' '}
              </Form.Group>
            </Col>
          </Row>

          <button className='btonn bton--lg bton--primary'>Submit </button>
        </Form>
      </Container>
    </div>
  );
};

export default ContactBox;
